import React, {useState} from "react";
import {CardBasic, CustomCheck, PrimaryButton} from "extranet-component-library";
import {observer} from "mobx-react";
import {useStores} from "../hooks/useStores";

import {useTranslation, Trans} from "react-i18next";
import {isMobile, isYoungProfile} from "../utils/parsers";

const StudentYoungProfileConfirmForm = observer(() => {

    const {t} = useTranslation();
    const {myTibStore} = useStores();
    const {profile, settings} = myTibStore;

    const [config, setConfig] = useState({
        isStudent: true,
        pinbalAuth: true,
        userAuthRefuse: false,
    });

    const onSettingsSaved = () => {

        const {isStudent, pinbalAuth} = config;
        const data = {isStudent, pinbalAuth};

        myTibStore.updateStudentProfile(data);

    };

    const isYoungUserProfile = isYoungProfile(profile.birthday);

    // forced false for desable feature
    const showStudentProfileClaim = (isYoungUserProfile: boolean, isStudent: boolean): false => {
        if (isYoungUserProfile && !isStudent) {
            return false;
        } else {
            return false;
        }
    }

    let showStudentClaim = false;
    if (settings !== undefined) {
        showStudentClaim = showStudentProfileClaim(isYoungUserProfile, settings.isStudent);
    } else {
        console.error('settings is undefined');
    }

    return (

        <CardBasic
            style={{
                width: isMobile() ? "95%" : "100%",
                margin: isMobile() ? "0.5rem" : "2% 0 0 0",
            }}
            content={
                showStudentClaim && (
                    <div data-testid="student-profile-form-container" className="student-profile-form-container">
                        <div className="title">{t("student_profile_confirm.title")}</div>
                        <div className="checks-title">{t("student_profile_confirm.law_info")}</div>
                        <div className="checks-title">{t("student_profile_confirm.refuse_title")}</div>

                        <div className="favs-check">
                            <CustomCheck
                                id={t("student_profile_confirm.refuse_checkbox_label")}
                                label={t("student_profile_confirm.refuse_checkbox_label")}
                                checked={config.userAuthRefuse}
                                onCheckboxChanged={(e) =>
                                    setConfig({...config, userAuthRefuse: e, pinbalAuth: !e})
                                }
                            />
                        </div>
                        <div className="checks-title">
                            <b>{t("student_profile_confirm.student_profile_title_description")}</b> {t("student_profile_confirm.student_profile_description")}
                        </div>
                        <div className="checks-title">
                            <b>{t("student_profile_confirm.required_title_documents")}</b> {t("student_profile_confirm.required_documents")}
                        </div>
                        <br/>
                        <div className="favs-check">
                            <CustomCheck
                                id="user_auth_checkbox"
                                label={<Trans i18nKey="student_profile_confirm.user_auth_checkbox_label"/>}
                                checked={config.pinbalAuth}
                                onCheckboxChanged={(e) =>
                                    setConfig({...config, pinbalAuth: e, userAuthRefuse: !e})
                                }
                            />
                        </div>
                        <br/>
                        <div className="favs-check">
                            <CustomCheck
                                id={t("student_profile_confirm.user_state_checkbox_label")}
                                label={t("student_profile_confirm.user_state_checkbox_label")}
                                checked={config.isStudent}
                                onCheckboxChanged={(e) =>
                                    setConfig({...config, isStudent: e})
                                }
                            />
                        </div>
                        <div style={{textAlign: "center", paddingTop: "3rem"}}>
                            <PrimaryButton
                                text={t("save_settings")}
                                onClick={() => onSettingsSaved()}
                            />
                        </div>
                    </div>
                )

            }
        />
    );
});

export default StudentYoungProfileConfirmForm;
